module.exports = "/static/assets/7fcd003c4a63163684ba889c2030b9ad.png";